import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import { IconAvatarLumaBot } from 'icons';

import Avatar, { AvatarProps } from './Avatar';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      boxSizing: 'border-box',
      fontSize: theme.typography.pxToRem(48),
      backgroundColor: '#ffdbc6',
      color: '#fff',
      width: 27,
      height: 27,
    },
  });

export interface AvatarLumaBotProps extends WithStyles<typeof styles>, Omit<AvatarProps, 'classes' | 'children'> {
  user?: string;
}

const AvatarLumaBot: React.FC<AvatarLumaBotProps> = ({ classes, src, ...rest }) => {
  if (!src) {
    return (
      <Avatar className={classes.root}>
        <IconAvatarLumaBot fontSize="small" />
      </Avatar>
    );
  }

  return (
    <Avatar className={classes.root} src={src} {...rest}>
      <PersonIcon />
    </Avatar>
  );
};

export default withStyles(styles, { name: 'AvatarLumaBot' })(AvatarLumaBot);
